// 1. Import your CONFIGURED api instance
import api from '@/plugins/axios';

// 2. Define the base path
const SERVICE_PATH = '/symbol-service/api/v1/symbols';

// 3. DELETE all the interceptors. They are already in the imported 'api' instance.

export default {
  getAllSymbols() {
    // 4. Use the full path
    return api.get(SERVICE_PATH);
  },
  getCustomSymbols(userEmail) {
    return api.get(SERVICE_PATH, { 
      params: { 
        userId: userEmail, 
        type: 'CUSTOM' 
      }
    });
  },
  createSymbol(symbol) {
    return api.post(SERVICE_PATH, symbol);
  },
  updateSymbol(id, symbol) {
    return api.put(`${SERVICE_PATH}/${id}`, symbol);
  },
  deleteSymbol(id) {
    return api.delete(`${SERVICE_PATH}/${id}`);
  },
  searchSymbols(query, userEmail) {
    return api.get(`${SERVICE_PATH}/search`, { 
      params: { query, userId: userEmail }
    });
  },
  getSymbolByTicker(ticker) {
    const formattedTicker = ticker === 'USD' ? 'USDTRY' : ticker;
    return api.get(`${SERVICE_PATH}/${formattedTicker}`);
  },
  getSymbol(id) {
    return api.get(`${SERVICE_PATH}/${id}`); // Note: Path was likely wrong before
  },
  getExchangeRateForDate(year, month, day) {
    return api.get(SERVICE_PATH, {
      params: {
        year,
        month,
        day
      }
    });
  },
  getSymbolsByIds(symbolIds) {
    return api.post(`${SERVICE_PATH}/batch`, symbolIds);
  },
  getExchangeRate() {
    return api.get(`${SERVICE_PATH}/exchange-rate`);
  },
  browseSymbols({ query, types, page = 0, size = 20 } = {}) {
    const params = { page, size };
    if (query) params.query = query;
    if (types && types.length > 0) params.type = types;
    return api.get(`${SERVICE_PATH}/browse`, { params, paramsSerializer: { indexes: null } });
  },
};